import type { FC, ReactNode } from "react"

type Props = {
  children: ReactNode
  className?: string
}

export default function H2({
  children,
  className = "",
}: Props): ReturnType<FC<Props>> {
  const cs = ["text-3xl", className].join(" ").trim()
  return <h2 className={cs}>{children}</h2>
}
